module.exports = __webpack_public_path__ + "f847c9e4c728da2b366f14fdfb9d8b05.svg";